import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  customers: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    fetchCustomersStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCustomersSuccess(state, action) {
      state.customers = action.payload.customers;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchCustomersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addCustomerStart(state) {
      state.loading = true;
      state.error = null;
    },
    addCustomerSuccess(state, action) {
      state.loading = false;
      state.customers.unshift(action.payload);
      state.error = null;
    },
    addCustomerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteCustomerStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteCustomerSuccess(state, action) {
      state.loading = false;
      state.customers = state.customers.filter(
        (customer) => customer.id !== action.payload
      );
      state.error = null;
    },
    deleteCustomerFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editCustomerStart(state) {
      state.loading = true;
      state.error = null;
    },
    editCustomerSuccess(state, action) {
      state.loading = false;
      const updatedCustomer = action.payload;
      const index = state.customers.findIndex(
        (customer) => customer.id === updatedCustomer.id
      );
      if (index !== -1) {
        state.customers[index] = updatedCustomer;
      }
      state.error = null;
    },
    editCustomerFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetCustomers(state) {
      state.customers = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchCustomersStart,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  addCustomerStart,
  addCustomerSuccess,
  addCustomerFailure,
  deleteCustomerStart,
  deleteCustomerSuccess,
  deleteCustomerFailure,

  editCustomerStart,
  editCustomerSuccess,
  editCustomerFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetCustomers,
} = customerSlice.actions;

export default customerSlice.reducer;
